module.exports = __webpack_public_path__ + "img/t-martel.b4f2eecb.jpg";